import React, {PureComponent} from 'react'
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {showDocuSign, changeMessageBoxState} from "../../actions/actionFunctions";
import {HOST_NAME} from "../../api/api";

class DocuSignLayer extends PureComponent {
    componentDidMount() {
      this.setupDocuSignForm();
    }

    componentDidUpdate() {
      if(window.docuSignSuccess) {
        if (this.props.callback) {
          this.props.callback();
        }
        this.props.hideMe();
      }
    }

    setupDocuSignForm = () => {
        window.handleIFrameMessage = (e) => {
            if (typeof e.data === 'object') {
                const {event, error} = e.data;
                if (event) {
                    console.log('DocuSign', event);
                    if (this.props.callback) {
                        this.props.callback(event);
                    }
                    window.docuSignSuccess = true;
                    this.props.hideMe();
                    // QCDES-30 - Dont redirect anymore, just hide the layer.
                    // const {fabricatorWebSiteUrl} = this.props;
                    // if (fabricatorWebSiteUrl) {
                    //     window.location = fabricatorWebSiteUrl;
                    // }
                }
              else if(error) {
                let errorMsg = error;
                this.props.hideMe(this.props.callback);
                let jsonMatches = errorMsg.match(/(\{.*\})/g);
                if(jsonMatches && jsonMatches.length > 0) {
                  let jObj = JSON.parse(jsonMatches[0]);
                  if(jObj.message) {
                    errorMsg = jObj.message;
                  }
                }
                this.props.changeMessageBoxState({
                  visible: true,
                  error: true,
                  title: "messageBox.docusignError",
                  message: errorMsg,
                  buttons: [{
                    text: "messageBox.buttonOk",
                    color: "red",
                    click: () => {
                      this.props.changeMessageBoxState({visible: false});
                      if(this.props.callback) {
                        this.props.callback(error);
                      }
                    }
                  }]
                });
              }
            }
        }

        if (window.addEventListener) {
            window.addEventListener("message", handleIFrameMessage, false);
        } else if (window.attachEvent) {
            window.attachEvent("onmessage", handleIFrameMessage);
        }
    }

    render() {
        const {jobId, show} = this.props;

        if (!show) {
            return null;
        }

        // http://gfd.us/DocuSignLanding?jobId=302571
        const iFrameUrl = `${HOST_NAME}/DocuSignLanding?jobId=${jobId}&ceremonyType=checkout`;
        return (
            <div className="full-screen-wrapper">
                <iframe
                    id={"docuSignFrame-" + jobId}
                    onLoad={window.parent.scrollTo(0, 0)}
                    allowFullScreen={true}
                    allow=""
                    // allow="geolocation; microphone; camera"
                    src={iFrameUrl}
                    frameBorder="0"
                    scrolling="yes"
                    style={{width: '100%', height: 'calc(100% - 35px)'}}
                >
                </iframe>
            </div>
        )
    }
}


DocuSignLayer.propTypes = {
    jobId: PropTypes.number,
    show: PropTypes.bool.isRequired,
    callback: PropTypes.func,
    hideMe: PropTypes.func.isRequired,
    fabricatorWebSiteUrl: PropTypes.string
}

const mapStateToProps = state => {
    const {docuSignState, serverState, fabricatorState} = state;
    return {
        show: docuSignState.show,
        callback: docuSignState.callback,
        jobId: serverState.jobId,
        windowWidth: serverState.windowWidth,
        windowHeight: serverState.windowHeight,
        fabricatorWebSiteUrl: fabricatorState.websiteUrl
    }
}

const mapDispatchToProps = dispatch => {
    return {
        hideMe: (callback) => dispatch(showDocuSign(false, callback)),
        changeMessageBoxState: (newMsgBoxState) => dispatch(changeMessageBoxState(newMsgBoxState))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DocuSignLayer);


